import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';
import Dialog from 'fe-design-base/organisms/Dialog';

import { toggleAddEmployeeWarningModalOpen } from 'actions/addTeam';

import { getAddEmployeeWarningModalOpen } from 'selectors/addTeam';

import { toI18n } from 'util/i18n';

import { PAY_ANYWHERE_ADD_TEAM_LINK } from '../constants';

const AddEmployeeWarningModal = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(getAddEmployeeWarningModalOpen);

  const handleClose = useCallback(() => {
    dispatch(toggleAddEmployeeWarningModalOpen(false));
  }, [dispatch]);

  const handleClick = useCallback(() => {
    window.open(PAY_ANYWHERE_ADD_TEAM_LINK, '_blank');
    handleClose();
  }, [handleClose]);

  return (
    <Dialog
      open={isOpen}
      title={toI18n('add_team.add_employee_warning.title')}
      onClose={handleClose}
      buttons={[
        {
          variant: 'primary',
          onClick: handleClick,
          label: toI18n('add_team.add_employee_warning.button'),
        },
        {
          variant: 'tertiary',
          onClick: handleClose,
          label: toI18n('actions.cancel'),
        },
      ]}
    >
      {() => (
        <Box maxw={500} column>
          <Box hcenter>
            <Text i18n="add_team.add_employee_warning.description" />
          </Box>
        </Box>
      )}
    </Dialog>
  );
};

export default AddEmployeeWarningModal;
